import api from './api.js';

export const callApiGet = async ({ url, headers = {}}) => {
    try {
        return await api.get(url, {headers});
    } catch (error) {
        throw error.response;
    }
};

export const callApiPost = async ({ url, data, headers}) => {
    try {
        return await api.post(url, data, {headers});
    } catch (error){
        throw error.response || error;
    }
};

export const callApiPut = async ({ url, data, headers}) => {
    try {
        return await api.put(url, data, {headers});
    }catch (error){
        throw error.response;
    }
};

export const callApiPatch = async ({ url, data, headers}) => {
    try {
        return await api.patch(url, data, {headers});
    } catch (error){
        throw error.response;
    }
};